(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[284],{

/***/ 5270:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tester_product",
      function () {
        return __webpack_require__(8618);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fm": function() { return /* binding */ transformPriceToNumber; },
/* harmony export */   "zF": function() { return /* binding */ transformPrice; }
/* harmony export */ });
/* unused harmony export formatPrice */
var transformPrice = function(price, locale, currency) {
    var value = typeof price === "number" ? price / 100 : 0;
    try {
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency !== null && currency !== void 0 ? currency : "eur",
            currencyDisplay: "narrowSymbol",
            minimumFractionDigits: 0
        }).format(value);
    } catch (e) {
        // Support pour les vieux navigateurs
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency !== null && currency !== void 0 ? currency : "eur",
            currencyDisplay: "symbol",
            minimumFractionDigits: 0
        }).format(value);
    }
};
var transformPriceToNumber = function(price) {
    var value = typeof price === "number" ? price / 100 : 0;
    return value.toFixed(2);
};
var formatPrice = function(value, locale, currency) {
    try {
        return Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency !== null && currency !== void 0 ? currency : "eur",
            currencyDisplay: "narrowSymbol",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(value);
    } catch (e) {
        // Support pour les vieux navigateurs
        return Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency !== null && currency !== void 0 ? currency : "eur",
            currencyDisplay: "symbol",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(value);
    }
};


/***/ }),

/***/ 3415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Mf": function() { return /* reexport */ ModalImageComponent; },
  "U8": function() { return /* reexport */ ProductCarouselComponent; }
});

// UNUSED EXPORTS: CloseComponent

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4364);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(619);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(4658);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ./components/external/close/close-component.module.scss
var close_component_module = __webpack_require__(2369);
var close_component_module_default = /*#__PURE__*/__webpack_require__.n(close_component_module);
;// CONCATENATED MODULE: ./components/external/close/close-component.tsx






var iconClose = "https://site.appchoose.io/external/icons/ic-close-white.svg";
var CloseComponent = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CloseComponent, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(CloseComponent);
    function CloseComponent() {
        (0,_class_call_check/* default */.Z)(this, CloseComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.onClose = function() {
            _this.props.onClose();
        };
        return _this;
    }
    var _proto = CloseComponent.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((close_component_module_default()).close, " animated fadeIn"),
            onClick: this.onClose,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: "close",
                src: iconClose
            })
        });
    };
    return CloseComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(1151);
// EXTERNAL MODULE: ./components/external/modal-image/modal-image-component.module.scss
var modal_image_component_module = __webpack_require__(4586);
var modal_image_component_module_default = /*#__PURE__*/__webpack_require__.n(modal_image_component_module);
// EXTERNAL MODULE: ./utils/image.ts
var utils_image = __webpack_require__(5350);
// EXTERNAL MODULE: ./utils/agent.ts + 1 modules
var agent = __webpack_require__(9754);
;// CONCATENATED MODULE: ./components/external/modal-image/modal-image-component.tsx







// import LazyImage from "../../lazy-image/lazy-image";


var icon = "https://site.appchoose.io/external/icons/ic-close-black.svg";
var ModalImageComponent = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ModalImageComponent, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(ModalImageComponent);
    function ModalImageComponent() {
        (0,_class_call_check/* default */.Z)(this, ModalImageComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.focused = _this.props.focusOn || 0;
        _this.state = {
            userAgent: {}
        };
        _this.focusOnImg = function() {
            var imgs = _this.ref.querySelectorAll("img");
            var elt = imgs[_this.focused];
            if (elt && typeof elt.scrollIntoView === "function") {
                elt.scrollIntoView({
                    block: "center"
                });
            }
        };
        _this.onPressKeyDown = function(event) {
            switch(event.keyCode){
                case 27:
                    if (typeof _this.props.onClose === "function") {
                        _this.props.onClose();
                    }
                    break;
                case 40:
                case 39:
                    event.preventDefault();
                    _this.focused = _this.focused >= _this.props.images.length - 1 ? _this.props.images.length - 1 : _this.focused + 1;
                    _this.focusOnImg();
                    break;
                case 38:
                case 37:
                    event.preventDefault();
                    _this.focused = _this.focused <= 0 ? 0 : _this.focused - 1;
                    _this.focusOnImg();
                    break;
                default:
                    break;
            }
        };
        _this.onClose = function() {
            if (typeof _this.props.onClose === "function") {
                _this.props.onClose();
            }
        };
        _this.onClickImage = function(event) {
            event.stopPropagation();
        };
        _this.onLoad = function() {
            _this.focusOnImg();
        };
        return _this;
    }
    var _proto = ModalImageComponent.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.focusOnImg();
        var userAgent = (0,agent/* getUserAgent */.i)();
        this.setState({
            userAgent: userAgent
        });
        document.addEventListener("keydown", this.onPressKeyDown);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        document.removeEventListener("keydown", this.onPressKeyDown);
    };
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (modal_image_component_module_default()).modal,
            onClick: this.onClose,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (modal_image_component_module_default()).close,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: "close",
                        src: icon
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: function(c) {
                        if (c) {
                            _this.ref = c;
                        }
                    },
                    className: "container ".concat((modal_image_component_module_default()).image),
                    onLoad: this.onLoad,
                    children: this.renderImages
                })
            ]
        });
    };
    (0,_create_class/* default */.Z)(ModalImageComponent, [
        {
            key: "renderImages",
            get: function get() {
                var _this = this;
                return this.props.images.map(function(image, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: _this.props.imageClassName,
                        onClick: _this.onClickImage,
                        src: (0,utils_image/* transformImage */.W)(image, "1500x", undefined, _this.state.userAgent.hasWebp),
                        alt: "Image produit"
                    }, "".concat(image, "-").concat(idx));
                });
            }
        }
    ]);
    return ModalImageComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./components/external/product-carousel/product-carousel-component.module.scss
var product_carousel_component_module = __webpack_require__(4955);
var product_carousel_component_module_default = /*#__PURE__*/__webpack_require__.n(product_carousel_component_module);
// EXTERNAL MODULE: ../node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(4837);
;// CONCATENATED MODULE: ./components/external/product-carousel/product-carousel-component.tsx









var ProductImages = /*#__PURE__*/ react.memo(function ProductImages(param) {
    var images = param.images, onClickItem = param.onClickItem;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(js/* Carousel */.lr, {
        className: (product_carousel_component_module_default()).carousel,
        onClickItem: onClickItem,
        showArrows: false,
        showStatus: false,
        autoPlay: false,
        showThumbs: false,
        swipeable: true,
        children: images && images.length > 1 ? images.map(function(image, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: "product image ".concat(index),
                // , ${ transformImage(image.image, '1557x1557', undefined, userAgent.hasWebp).replace('full-fit-in/', '') } 3x
                srcSet: "".concat((0,utils_image/* transformImage */.W)(image.url, "1038x1038").replace("full-fit-in/", ""), " 2x"),
                src: (0,utils_image/* transformImage */.W)(image.url, "671x671").replace("full-fit-in/", "")
            }, index);
        }) : null
    });
});
var ProductCarouselComponent = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ProductCarouselComponent, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(ProductCarouselComponent);
    function ProductCarouselComponent() {
        (0,_class_call_check/* default */.Z)(this, ProductCarouselComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            selected: (0,utils_image/* transformImage */.W)(Array.isArray(_this.props.images) && _this.props.images[0] ? _this.props.images[0].url : "", "519x519", undefined, false).replace("full-fit-in/", "")
        };
        _this.onChangeImage = function(idxSelected) {
            if (_this.props.images) {
                _this.setState({
                    selected: (0,utils_image/* transformImage */.W)(_this.props.images[idxSelected].url, "519x519").replace("full-fit-in/", "")
                });
            }
        };
        _this.onSelect = function(idxSelected) {
            if (typeof _this.props.onSelect === "function") {
                _this.props.onSelect(idxSelected);
            }
            _this.onChangeImage(idxSelected);
        };
        _this.onClickItem = function(idxSelected) {
            _this.props.onClickModal(idxSelected);
        };
        _this.getClassName = function(index) {
            if (_this.props.idxSelected === index) {
                return (product_carousel_component_module_default()).active + " image-container";
            }
            return "image-container";
        };
        _this.onClickImage = function() {
            _this.props.onClickModal();
        };
        return _this;
    }
    var _proto = ProductCarouselComponent.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: this.getClassNameContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "".concat((product_carousel_component_module_default()).sidebar, " col-md-2 col-sm-0 col-2"),
                    children: this.props.images && this.props.images.length > 1 ? this.props.images.map(function(image, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: _this.getClassName(index),
                            onClick: _this.onSelect.bind(_this, index),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "sm_image ".concat(index),
                                onClick: _this.onSelect.bind(_this, index),
                                src: (0,utils_image/* transformImage */.W)(image.url, "85x85").replace("full-fit-in/", ""),
                                srcSet: "".concat((0,utils_image/* transformImage */.W)(image.url, "170x170").replace("full-fit-in/", ""), " 2x, ").concat((0,utils_image/* transformImage */.W)(image.url, "255x255").replace("full-fit-in/", ""), " 3x")
                            })
                        }, index);
                    }) : null
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: "col-md-10 ".concat(this.props.images && this.props.images.length === 1 ? "col-12" : "col-10", " col-sm-12"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "image selected",
                            // , ${this.state.selected.replace('519x519', '1557x1557')} 3x
                            srcSet: "".concat(this.state.selected.replace("519x519", "1038x1038"), " 2x"),
                            src: this.state.selected,
                            onClick: this.onClickImage
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImages, {
                    images: this.props.images,
                    onClickItem: this.onClickItem
                })
            ]
        });
    };
    (0,_create_class/* default */.Z)(ProductCarouselComponent, [
        {
            key: "getClassNameContainer",
            get: function get() {
                var text = (product_carousel_component_module_default()).product + " col-6 col-sm-12 col-md-12";
                if (this.props.className) {
                    text += " " + this.props.className;
                }
                if (this.props.images && this.props.images.length === 1) {
                    text += " " + (product_carousel_component_module_default()).single;
                }
                return text;
            }
        }
    ]);
    return ProductCarouselComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/external/index.ts






/***/ }),

/***/ 1634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ FAQComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4364);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1151);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(619);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4658);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _faq_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8439);
/* harmony import */ var _faq_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_faq_module_scss__WEBPACK_IMPORTED_MODULE_5__);







var FAQComponent = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(FAQComponent, _PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(FAQComponent);
    function FAQComponent() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, FAQComponent);
        return _super.apply(this, arguments);
    }
    var _proto = FAQComponent.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
            className: "".concat((_faq_module_scss__WEBPACK_IMPORTED_MODULE_5___default().faq), " ").concat(this.props.style || ""),
            children: this.getFaq.map(function(faq, idx) {
                var withTitle = typeof faq !== "string";
                var text = withTitle ? faq.description : faq;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_5___default().rounded),
                            children: idx + 1
                        }),
                        typeof faq !== "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: faq.title
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            dangerouslySetInnerHTML: {
                                __html: text
                            }
                        })
                    ]
                }, idx);
            })
        });
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(FAQComponent, [
        {
            key: "getFaq",
            get: function get() {
                return this.props.faq;
            }
        }
    ]);
    return FAQComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);


/***/ }),

/***/ 8618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ tester_product; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(3842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4364);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(1151);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(619);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(2050);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(719);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(2126);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(2164);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(4658);
// EXTERNAL MODULE: ../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(5230);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ./styles/pages/sale.module.scss
var sale_module = __webpack_require__(6002);
var sale_module_default = /*#__PURE__*/__webpack_require__.n(sale_module);
// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ./api/currency.ts
var currency = __webpack_require__(5283);
// EXTERNAL MODULE: ./utils/date.ts
var date = __webpack_require__(2251);
// EXTERNAL MODULE: ./utils/image.ts
var utils_image = __webpack_require__(5350);
// EXTERNAL MODULE: ./components/meta-header/meta-header.tsx
var meta_header = __webpack_require__(6514);
// EXTERNAL MODULE: ./api/analytics.ts
var analytics = __webpack_require__(1936);
// EXTERNAL MODULE: ./components/external/index.ts + 3 modules
var external = __webpack_require__(3415);
// EXTERNAL MODULE: ./components/lazy-product-image/lazy-product-image.tsx
var lazy_product_image = __webpack_require__(6511);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 30 modules
var esm = __webpack_require__(3496);
// EXTERNAL MODULE: ./config.ts
var config = __webpack_require__(1340);
// EXTERNAL MODULE: ./utils/lang.ts
var lang = __webpack_require__(3703);
// EXTERNAL MODULE: ./new-components/header-test/HeaderTest.tsx
var HeaderTest = __webpack_require__(6273);
// EXTERNAL MODULE: ./new-components/footer-test/FooterTest.tsx
var FooterTest = __webpack_require__(6558);
// EXTERNAL MODULE: ./components/faq/faq.tsx
var faq = __webpack_require__(1634);
;// CONCATENATED MODULE: ./pages/tester_product.tsx










// import "../styles/pages/sale.scss"














var transformModele = function(key) {
    if (key === 0) {
        return "F\xe9minin";
    } else if (key === 1) {
        return "Masculin";
    }
    return "Unisexe";
};
var ProductScreen = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ProductScreen, _Component);
    var _super = (0,_create_super/* default */.Z)(ProductScreen);
    function ProductScreen() {
        (0,_class_call_check/* default */.Z)(this, ProductScreen);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            selectedImageId: 0,
            displayModal: false
        };
        _this.getTrad = function(str) {
            return _this.props.t(str);
        };
        _this.onModalClick = function() {
            _this.setState({
                displayModal: !_this.state.displayModal
            });
        };
        _this.onImageSelect = function(selectedImageId) {
            _this.setState({
                selectedImageId: selectedImageId
            });
        };
        _this.onClick = function() {
            var id = _this.props.router.query.id && _this.props.router.query.id.indexOf("@v=") > -1 ? _this.props.router.query.id.split("@v=")[1] : undefined;
            _this.props.router.push("/testing/" + _this.props.product.sale_id + "@v=" + id + "?name=" + _this.props.product.brand_name);
        };
        return _this;
    }
    var _proto = ProductScreen.prototype;
    _proto.displayDifferentPrices = function displayDifferentPrices() {
        var _Math, _Math1;
        var min = (_Math = Math).min.apply(_Math, _toConsumableArray(this.props.product.variants.map(function(c) {
            return c.formatted_price;
        })));
        var max = (_Math1 = Math).max.apply(_Math1, _toConsumableArray(this.props.product.variants.map(function(c) {
            return c.formatted_price;
        })));
        return this.props.product.variants.length > 1 && min !== max;
    };
    _proto.renderDeliveryDelays = function renderDeliveryDelays(min, max) {
        if (this.props.product.type === "coupon") {
            return null;
        }
        if (min === max) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    this.props.t("deliverydelays"),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            min,
                            " ",
                            this.props.t("day")
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                this.props.t("deliverydelays"),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        " ",
                        min,
                        " - ",
                        max,
                        " ",
                        this.props.t("day")
                    ]
                })
            ]
        });
    };
    _proto.getDeliveryOfferLabel = function getDeliveryOfferLabel(type) {
        switch(type){
            case "StandardHomeDelivery":
                return this.props.t("shipping.StandardHomeDelivery");
            case "StandardPickupDelivery":
                return this.props.t("shipping.StandardPickupDelivery");
            case "ExpressHomeDelivery":
                return this.props.t("shipping.ExpressHomeDelivery");
            default:
                return type;
        }
    };
    /**
   * The minimum order amount shared by every delivery offer, `null` as soon as
   * they differ. When they all share the same one, it is displayed on a single
   * line instead of on each delivery offer.
   */ _proto.getCommonFreeShippingOverOrderAmount = function getCommonFreeShippingOverOrderAmount(policiesByDeliveryOffer) {
        var _policiesByDeliveryOffer = (0,_sliced_to_array/* default */.Z)(policiesByDeliveryOffer, 1), firstPolicy = _policiesByDeliveryOffer[0];
        var ref;
        var firstAmount = (ref = firstPolicy === null || firstPolicy === void 0 ? void 0 : firstPolicy.free_shipping_over_order_amount) !== null && ref !== void 0 ? ref : null;
        return firstAmount && policiesByDeliveryOffer.every(function(policy) {
            return policy.free_shipping_over_order_amount === firstAmount;
        }) ? firstAmount : null;
    };
    _proto.renderFreeShippingOverOrderAmountLine = function renderFreeShippingOverOrderAmountLine(freeShippingOverOrderAmount, deliveryOfferLabel, key) {
        if (!freeShippingOverOrderAmount) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                deliveryOfferLabel,
                this.props.t("francoport"),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        " ",
                        (0,currency/* transformPrice */.zF)(freeShippingOverOrderAmount, this.props.i18n.language, this.props.product.currency)
                    ]
                })
            ]
        }, key);
    };
    // tslint:disable-next-line:cognitive-complexity
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (_this.props.product) {
                            (0,analytics/* trackPage */.K)("Product", {
                                id: _this.props.product.id,
                                tester: true
                            });
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.renderSizes = function renderSizes(option) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (sale_module_default()).sizes,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                            children: [
                                option.values.length,
                                " ",
                                option.name,
                                option.values.length > 1 ? "s" : ""
                            ]
                        }),
                        " ",
                        this.props.t("available"),
                        option.values.length > 1 ? "s" : "",
                        " :"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: option.values.map(function(size) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: size
                            })
                        }, size);
                    })
                })
            ]
        }, option.name);
    };
    // public get renderVariants() {
    //   if (this.props.product.variants) {
    //     return this.props.product.variants
    //       .map((c) => {
    //         // return this.renderSizes(c);
    //         const option = c.options.map((o)=>o.value).join('-')
    //         const image = c.images.length ? this.props.product.images.find((i)=>i.key === c.images[0])?.url : ""
    //         return <div>
    //           <img src={transformImage(image,"80x80")} />
    //           <p>{option}</p>
    //           <p className={styles.price_formatted}>
    //                 {transformPriceWithCurrency(
    //                   c.formatted_price as number,
    //                   this.props.i18n.language || "fr",
    //                   this.props.product.currency
    //                 )}
    //                 {/* {this.props.product.formatted_price} */}
    //               </p>
    //         </div>
    //       });
    //   }
    //   return null;
    // }
    _proto.displayDetails = function displayDetails() {
        return Array.isArray(this.props.product.details) || this.displayDifferentPrices();
    };
    // tslint:disable-next-line:cognitive-complexity
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (sale_module_default()).sale + " " + (sale_module_default()).tester,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(meta_header/* default */.Z, {
                    canonical: config/* canonical */.fK + "product/" + this.props.product.url,
                    keywords: this.props.product.subtitle + "," + this.props.product.brand_name,
                    appleArguments: this.getAppleMeta,
                    pageTitle: this.getTitle,
                    isSquare: true,
                    description: this.getDescription,
                    title: this.getTitle,
                    image: this.getMainImage,
                    noIndex: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTest/* HeaderTesterComponent */.L, {
                    link: this.props.history[0].path,
                    name: this.props.product.title || this.props.product.brand_name,
                    onClick: this.onClick
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container align-items-center ".concat((sale_module_default()).margin),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (sale_module_default()).breadcrump,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: this.props.history[0].path,
                                    children: this.props.history[0].value
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "/"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: this.props.history[1].path,
                                    children: this.props.history[1].value
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row ".concat((sale_module_default()).sale_data, " ").concat((sale_module_default()).product_data),
                            children: [
                                !this.state.displayModal ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(external/* ModalImageComponent */.Mf, {
                                    images: this.props.product.images.map(function(c) {
                                        return c.url;
                                    }),
                                    focusOn: this.state.selectedImageId,
                                    onClose: this.onModalClick
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(external/* ProductCarouselComponent */.U8, {
                                    images: this.props.product.images,
                                    onClickModal: this.onModalClick,
                                    className: (sale_module_default()).carousel,
                                    onSelect: this.onImageSelect,
                                    idxSelected: this.state.selectedImageId
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-sm-0 col-1 col-md-2 ".concat((sale_module_default()).separation)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-4 col-md-8 col-sm-12 ".concat((sale_module_default()).sale_info),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: (sale_module_default()).title_brand,
                                            children: this.props.product.title || this.props.product.brand_name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (sale_module_default()).title_product,
                                            children: this.props.product.subtitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (sale_module_default()).prices,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: (sale_module_default()).price_formatted,
                                                    children: (0,currency/* transformPrice */.zF)(this.props.product.formatted_price, this.props.i18n.language || "fr", this.props.product.currency)
                                                }),
                                                this.props.product.price !== this.props.product.formatted_price ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: (sale_module_default()).price_normal,
                                                    children: (0,currency/* transformPrice */.zF)(this.props.product.price, this.props.i18n.language || "fr", this.props.product.currency)
                                                }) : null,
                                                this.ecoPart
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            children: this.props.t("addtocart")
                                        }),
                                        this.renderOptions,
                                        this.renderShipping,
                                        this.renderCashback
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-sm-0 col-2 col-md-2 ".concat((sale_module_default()).separation)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-8 col-md-8 col-sm-12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                            className: (sale_module_default()).sale_hr
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            children: "Description"
                                        }),
                                        this.props.product.badges ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (sale_module_default()).badges,
                                            children: this.props.product.badges.map(function(badge) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (sale_module_default()).badge,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_product_image/* default */.Z, {
                                                            height: "16",
                                                            width: "16",
                                                            disableWebp: true,
                                                            src: badge.image,
                                                            alt: badge.text
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: _this.props.t(badge.code)
                                                        })
                                                    ]
                                                }, badge.text);
                                            })
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (sale_module_default()).description,
                                            children: this.props.product.description
                                        }),
                                        this.displayDetails() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (sale_module_default()).details,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                    className: (sale_module_default()).sale_hr
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: this.props.t("details")
                                                }),
                                                this.renderPrices,
                                                this.renderDetails
                                            ]
                                        }) : null,
                                        this.props.product.type === "coupon" ? this.renderFaq : null,
                                        this.props.product.type === "coupon" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cgu",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                    className: (sale_module_default()).sale_hr + " " + (sale_module_default()).hrlight
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: this.getTrad("how_it_works")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: (sale_module_default()).cguText,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            alt: "info",
                                                            src: "https://public.choose.app/website/new/images/Info.svg",
                                                            height: "16",
                                                            width: "16"
                                                        }),
                                                        this.getTrad("valid_until"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            children: (0,date/* formatBasic */.CI)(this.props.product.coupon_expire_at, (0,lang/* getLang */.V)(this.props.i18n), this.props.sale.store)
                                                        })
                                                    ]
                                                }),
                                                Array.isArray(this.props.product.cgu) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: (sale_module_default()).cgu,
                                                    children: this.props.product.cgu.slice(0, 3).map(function(cgu) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: cgu
                                                        }, cgu);
                                                    })
                                                }) : null
                                            ]
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterTest/* default */.Z, {
                    url: this.props.product.sale_id
                })
            ]
        });
    };
    (0,_create_class/* default */.Z)(ProductScreen, [
        {
            key: "getTitle",
            get: function get() {
                if (this.props.product && this.props.product.brand_name) {
                    return "".concat(this.props.product.brand_name, " - ").concat(this.props.product.subtitle, "\xa0| ").concat(this.getTrad("sale_ongoing"));
                }
                return "";
            }
        },
        {
            key: "getDescription",
            get: function get() {
                if (this.props.sale.sale_ended) {
                    return "".concat(this.props.product.brand_name, " - ").concat(this.props.product.subtitle, " ").concat(this.getTrad("discover"), ". ").concat(this.getTrad("sale_delivery"));
                } else if (this.props.sale.sale_started) {
                    return "".concat(this.props.product.brand_name, " - ").concat(this.props.product.subtitle, " ").concat(this.getTrad("discover"), " ").concat(this.getTrad("basic"), " ").concat((0,date/* formatPublicHome */.kC)(this.props.sale.end_at, (0,lang/* getLang */.V)(this.props.i18n), this.props.sale.store), ". ").concat(this.getTrad("sale_delivery"));
                }
                return "".concat(this.props.product.brand_name, " - ").concat(this.props.product.subtitle, " ").concat(this.getTrad("discover"), " ").concat(this.getTrad("basic"), " ").concat((0,date/* formatNextHome */.Ec)(this.props.sale.start_at, this.props.sale.end_at, (0,lang/* getLang */.V)(this.props.i18n), this.props.sale.store), ". ").concat(this.getTrad("sale_delivery"));
            }
        },
        {
            key: "getMainImage",
            get: function get() {
                if (this.props.product && Array.isArray(this.props.product.images) && this.props.product.images[0]) {
                    return (0,utils_image/* transformImage */.W)(this.props.product.images[0].url, "750");
                // return `https://img.appchoose.io/unsafe/630x630/filters:watermark(https://public.choose.app/website/new/images/logo-${
                //   this.props.product.images[0].dark_color ? "white" : "black"
                // }.png,158,272,50)/prod/${
                //   this.props.product.images[0].url.split("/prod/")[1]
                // }`;
                }
            }
        },
        {
            key: "isAvailable",
            get: function get() {
                if (this.props.sale) {
                    return !this.props.sale.sale_ended && this.props.sale.sale_started && !this.props.product.tester;
                }
                return undefined;
            }
        },
        {
            key: "getAppleMeta",
            get: function get() {
                if (this.props.product) {
                    var ref, ref1;
                    if (!((ref = this.props.sale) === null || ref === void 0 ? void 0 : ref.single_offer) && ((ref1 = this.props.sale) === null || ref1 === void 0 ? void 0 : ref1.url)) {
                        return "chooseapp://sales/".concat(encodeURIComponent(this.props.sale.url));
                    }
                    return "chooseapp://product/".concat(encodeURIComponent(this.props.product.url));
                }
            }
        },
        {
            key: "getAvailability",
            get: function get() {
                if (this.props.sale) {
                    if (this.props.sale.sale_ended) {
                        return "https://schema.org/Discontinued";
                    } else if (this.props.sale.sale_started) {
                        return this.props.product.stock !== 0 ? "http://schema.org/InStock" : "http://schema.org/OutOfStock";
                    }
                }
                return "https://schema.org/PreOrder";
            }
        },
        {
            key: "getGender",
            get: function get() {
                if (this.props.product) {
                    if (this.props.product.gender === 0) {
                        return "female";
                    } else if (this.props.product.gender === 1) {
                        return "male";
                    }
                    return "unisex";
                }
                return "unisex";
            }
        },
        {
            key: "getText",
            get: function get() {
                if (this.props.sale.sale_ended) {
                    return this.getTrad("sale_ended");
                } else if (this.props.sale.sale_started) {
                    return "".concat(this.getTrad("sale_ongoing"), " ").concat((0,date/* formatPublicHome */.kC)(this.props.sale.end_at, (0,lang/* getLang */.V)(this.props.i18n), this.props.sale.store));
                }
                return "".concat(this.getTrad("sale_next"), " ").concat((0,date/* formatNextHome */.Ec)(this.props.sale.start_at, this.props.sale.end_at, (0,lang/* getLang */.V)(this.props.i18n), this.props.sale.store));
            }
        },
        {
            key: "renderFaq",
            get: function get() {
                if (this.props.product.faq) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                className: (sale_module_default()).sale_hr + " " + (sale_module_default()).hrlight
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: this.getTrad("how_it_works")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(faq/* FAQComponent */.n, {
                                faq: this.props.product.faq
                            })
                        ]
                    });
                }
                return null;
            }
        },
        {
            key: "renderPrices",
            get: function get() {
                if (this.displayDifferentPrices()) {
                    var _this = this;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "col-2 col-md-12",
                                children: this.props.t("price")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "col-6 col-md-12",
                                dangerouslySetInnerHTML: {
                                    __html: this.props.product.variants.map(function(variant) {
                                        if (variant.options[variant.options.length - 1]) {
                                            return "".concat(variant.options.map(function(option) {
                                                return option.value;
                                            }).join(", "), " : ").concat((0,currency/* transformPrice */.zF)(variant.formatted_price, _this.props.i18n.language || "fr", _this.props.product.currency));
                                        }
                                        return "";
                                    }).join("<br/>")
                                }
                            })
                        ]
                    });
                }
                return null;
            }
        },
        {
            key: "ecoPart",
            get: function get() {
                if (this.props.product.eee_price) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (sale_module_default()).price_normal_eee,
                        children: [
                            this.props.t("ecopart"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: (0,currency/* transformPrice */.zF)(this.props.product.eee_price, this.props.i18n.language, this.props.product.currency)
                            })
                        ]
                    });
                }
                var ecoparts = this.props.product.variants.map(function(c) {
                    return c.eee_price;
                }).filter(function(c) {
                    return c > 0;
                });
                if (ecoparts.length) {
                    var _Math, _Math1;
                    var max = (_Math = Math).max.apply(_Math, _toConsumableArray(ecoparts));
                    var min = (_Math1 = Math).min.apply(_Math1, _toConsumableArray(ecoparts));
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (sale_module_default()).price_normal_eee,
                        children: [
                            this.props.t("ecopart"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: max === min ? (0,currency/* transformPrice */.zF)(max, this.props.i18n.language, this.props.product.currency) : "".concat((0,currency/* transformPrice */.zF)(min, this.props.i18n.language, this.props.product.currency), " - ").concat((0,currency/* transformPrice */.zF)(max, this.props.i18n.language, this.props.product.currency))
                            })
                        ]
                    });
                }
                return null;
            }
        },
        {
            key: "renderCashback",
            get: function get() {
                var _this = this;
                if (!this.props.product.cashback_policy) {
                    return;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (sale_module_default()).sizes,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: this.props.t("cashback")
                                })
                            }),
                            this.props.product.cashback_policy.thresholds.map(function(c) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        (0,currency/* transformPrice */.zF)(c.cashback_amount, _this.props.i18n.language, _this.props.product.currency),
                                        " ",
                                        _this.props.t("cashback_free"),
                                        " ",
                                        (0,currency/* transformPrice */.zF)(c.threshold, _this.props.i18n.language, _this.props.product.currency),
                                        " ",
                                        _this.props.t("cashback_purchase")
                                    ]
                                }, c.threshold);
                            })
                        ]
                    })
                });
            }
        },
        {
            key: "renderFreeShippingOverOrderAmount",
            get: /**
   * Franco de port, displayed on a single line when every delivery offer shares
   * the same minimum order amount, on one line per delivery offer otherwise.
   */ function get() {
                var _this = this;
                if (!this.props.product.shipping_policy || !this.props.product.delivery) {
                    return null;
                }
                var _policies_by_delivery_offer;
                var policiesByDeliveryOffer = (_policies_by_delivery_offer = this.props.product.shipping_policy.policies_by_delivery_offer) !== null && _policies_by_delivery_offer !== void 0 ? _policies_by_delivery_offer : [];
                if (!policiesByDeliveryOffer.length) {
                    return;
                }
                var commonFreeShippingOverOrderAmount = this.getCommonFreeShippingOverOrderAmount(policiesByDeliveryOffer);
                if (commonFreeShippingOverOrderAmount) {
                    return this.renderFreeShippingOverOrderAmountLine(commonFreeShippingOverOrderAmount);
                }
                return policiesByDeliveryOffer.map(function(policy) {
                    return _this.renderFreeShippingOverOrderAmountLine(policy.free_shipping_over_order_amount, _this.getDeliveryOfferLabel(policy.delivery_offer_key), policy.delivery_offer_key);
                });
            }
        },
        {
            key: "renderShipping",
            get: function get() {
                var _Math, _Math1;
                if (this.props.product.type === "coupon") {
                    return null;
                }
                var max = (_Math = Math).max.apply(_Math, _toConsumableArray(this.props.product.variants.map(function(c) {
                    return c.delivery_delays;
                })));
                var min = (_Math1 = Math).min.apply(_Math1, _toConsumableArray(this.props.product.variants.map(function(c) {
                    return c.delivery_delays;
                })));
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (sale_module_default()).sizes,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: this.props.t("shipping")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    " ",
                                    (0,currency/* transformPrice */.zF)(this.props.product.delivery, this.props.i18n.language, this.props.product.currency),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        style: {
                                            marginLeft: 8
                                        },
                                        children: this.props.product.delivery_offered_until ? this.props.t("offereduntil") + formatDate(this.props.product.delivery_offered_until, this.props.i18n.language) : ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    this.props.t("deliverby"),
                                    this.props.product.deliver_by_choose ? "Choose" : this.props.product.brand_name
                                ]
                            }),
                            this.renderFreeShippingOverOrderAmount,
                            this.renderDeliveryDelays(min, max)
                        ]
                    })
                });
            }
        },
        {
            key: "renderGender",
            get: function get() {
                if (typeof this.props.product.gender === "number") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "col-2 col-md-12",
                                children: "Mod\xe8le"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "col-6 col-md-12",
                                children: transformModele(this.props.product.gender)
                            })
                        ]
                    });
                }
                return null;
            }
        },
        {
            key: "renderDetails",
            get: function get() {
                if (Array.isArray(this.props.product.details)) {
                    return this.props.product.details.map(function(c) {
                        if (c.key === "Mod\xe8le") {
                            return null;
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "col-2 col-md-12",
                                    children: c.key
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "col-6 col-md-12",
                                    children: c.value
                                })
                            ]
                        }, c.key);
                    });
                }
            }
        },
        {
            key: "renderOptions",
            get: function get() {
                if (this.props.product.options) {
                    var _this = this;
                    return this.props.product.options.sort(function(a, b) {
                        return a.position > b.position ? 1 : -1;
                    }).map(function(c) {
                        return _this.renderSizes(c);
                    });
                }
                return null;
            }
        }
    ]);
    return ProductScreen;
}(react.Component);
var __N_SSP = true;
/* harmony default export */ var tester_product = ((0,esm/* withTranslation */.Zh)("sale")((0,router.withRouter)(ProductScreen)));
var formatDate = function(date, lang) {
    try {
        var d = new Date(date);
        return new Intl.DateTimeFormat(lang).format(d);
    } catch (error) {
        return "";
    }
};


/***/ }),

/***/ 2251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CI": function() { return /* binding */ formatBasic; },
/* harmony export */   "Ec": function() { return /* binding */ formatNextHome; },
/* harmony export */   "kC": function() { return /* binding */ formatPublicHome; }
/* harmony export */ });
/* unused harmony exports formatEnd, addDays, differenceInMinutes, differenceInHours, differenceInDays, isWeekend */
var formatEnd = function(endAt) {
    var d = new Date();
    var diff = differenceInDays(d, endAt);
    if (diff > 1) {
        return "".concat(diff, " jours restants");
    }
    var diffHours = differenceInHours(d, endAt);
    if (diffHours > 24) {
        return "1 jour restant";
    }
    if (diffHours > 1) {
        return "".concat(diffHours, "h restantes");
    }
    return "1h restante";
};
var formatBasic = function(endAt, lang, store) {
    var d = new Date(endAt);
    var LOCALE = lang === "fr" ? "fr-FR" : "en";
    return d.toLocaleDateString(LOCALE, {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
        timeZone: "UTC",
        timeZoneName: store === "us" ? "short" : undefined
    });
};
var formatPublicHome = function(end_at, lang, store) {
    var endAt = new Date(end_at);
    var LOCALE = lang === "fr" ? "fr-FR" : "en";
    var month = endAt.toLocaleDateString(LOCALE, {
        month: "long",
        timeZone: "UTC",
        timeZoneName: store === "us" ? "short" : undefined,
        weekday: "short",
        day: "numeric",
        hour: store === "us" ? "numeric" : undefined
    });
    var diff = Math.abs(differenceInHours(new Date(), endAt));
    var res = "";
    if (diff <= 24) {
        res = lang === "fr" ? "jusqu'\xe0 demain" : "until tomorrow";
    } else if (diff <= 48) {
        res = lang === "fr" ? "jusqu'apr\xe8s-demain" : "until the day after tomorrow";
    } else {
        res = lang === "fr" ? "jusqu'au ".concat(month) : "until ".concat(month);
    }
    return "<b>" + res + "</b>";
};
var formatNextHome = function(start_at, end_at, lang, store) {
    var startAt = new Date(start_at);
    var endAt = new Date(end_at);
    var LOCALE = lang === "fr" ? "fr-FR" : "en";
    // const dayEnd = endAt.toLocaleDateString(LOCALE, { weekday: 'long' });
    var dayEnd = endAt.toLocaleDateString(LOCALE, {
        month: "long",
        timeZone: "UTC",
        timeZoneName: store === "us" ? "short" : undefined,
        weekday: "short",
        day: "numeric",
        hour: store === "us" ? "numeric" : undefined
    });
    var diff = differenceInHours(new Date(), startAt);
    var res = "";
    if (diff <= 24) {
        res = lang === "fr" ? "de demain au ".concat(dayEnd) : "from tomorrow to ".concat(dayEnd);
    } else if (diff <= 48) {
        res = lang === "fr" ? "d'apr\xe8s-demain au ".concat(dayEnd) : "from the day after tomorrow to ".concat(dayEnd);
    } else {
        var day = startAt.toLocaleDateString(LOCALE, {
            weekday: "long",
            day: "numeric",
            timeZone: "UTC"
        });
        res = lang === "fr" ? "du ".concat(day, " au ").concat(dayEnd) : "from ".concat(day, " to ").concat(dayEnd);
    }
    return "<b>" + res + "</b>";
};
var addDays = function(date, days) {
    return new Date(date.getTime() + days * 60000 * 24 * 60);
};
var differenceInMinutes = function(start, end) {
    var t1 = start.getTime();
    var t2 = end.getTime();
    return Math.floor((t2 - t1) / 1000 / 60);
};
var differenceInHours = function(start, end) {
    var t1 = start.getTime();
    var t2 = end.getTime();
    return Math.floor((t2 - t1) / 1000 / 60 / 60);
};
var differenceInDays = function(start, end) {
    var t1 = start.getTime();
    var t2 = end.getTime();
    return Math.floor((t2 - t1) / 1000 / 60 / 60 / 24);
};
var isWeekend = function(date) {
    var day = date.getDay();
    return day === 6 || day === 0;
};


/***/ }),

/***/ 5350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ transformImage; }
/* harmony export */ });
var transformImage = function(image, sizes, removeFit, _webP) {
    if (image) {
        image = image.replace(":format(webp)", "").replace("resize:fit", "resize:fill");
        if (removeFit) {
            image = image.replace("full-fit-in/", "").replace("fit-in/", "");
        }
        return image.replace("[W]x[H]/", sizes + "/");
    }
    return "";
};


/***/ }),

/***/ 2369:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"close":"close-component_close__Zl7nU"};

/***/ }),

/***/ 4586:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-image-component_modal__A17ZC","image":"modal-image-component_image__z2qyg","lazy-image":"modal-image-component_lazy-image__Iyf_t","modal-image-component":"modal-image-component_modal-image-component__FZzni"};

/***/ }),

/***/ 4955:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product":"product-carousel-component_product__VVgT1","sidebar":"product-carousel-component_sidebar__7MRzs","active":"product-carousel-component_active__5BqNm","single":"product-carousel-component_single__T_pC7","carousel":"product-carousel-component_carousel__dcPh3"};

/***/ }),

/***/ 8439:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"faq":"faq_faq__Zie8D","rounded":"faq_rounded__zn9e_"};

/***/ }),

/***/ 6002:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sale":"sale_sale__wSg8c","prices":"sale_prices__qXF57","pricesproduct":"sale_pricesproduct__Tsnsi","discount":"sale_discount__1cslx","price_formatted":"sale_price_formatted__vsT2H","price_normal":"sale_price_normal__IJcnb","price_normal_eee":"sale_price_normal_eee__R6grx","tester":"sale_tester__IBTWH","sizes":"sale_sizes__Jmanb","margin":"sale_margin__wTO1F","hrlight":"sale_hrlight__vzcOJ","cguText":"sale_cguText__epXWa","cgu":"sale_cgu__i47Qt","sale_data":"sale_sale_data__2JMT9","product_data":"sale_product_data__0r9Vn","sale_info":"sale_sale_info__33qiu","stock":"sale_stock__dgg5M","breadcrump":"sale_breadcrump__UV1gL","products":"sale_products__ggtB8","badges":"sale_badges__S_adm","details":"sale_details__jLyR1","description":"sale_description__qyXGY","date":"sale_date___KEci","giveaway":"sale_giveaway__NumkQ","delivery":"sale_delivery__ok3rv","instagram":"sale_instagram__P7HLl","sale_hr":"sale_sale_hr__REAy7","badge":"sale_badge__07QCE","separation":"sale_separation__ZVKuY","carousel":"sale_carousel__Kp7TX","image":"sale_image__QP9WL","app":"sale_app__IyPAb","title_brand":"sale_title_brand__PBbHe","title_product":"sale_title_product__NutSy","category":"sale_category__vJSO9"};

/***/ }),

/***/ 6677:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5817)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [837,149,774,888,179], function() { return __webpack_exec__(5270); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);